import React from "react";
import { color } from "../../styles/theme";

const Input = ({ label, type = "text", value, onChange, placeholder = "", required = false, style = {}, ...rest }) => (
  <div style={{ marginBottom: 16 }}>
    {label && (
      <label style={{ display: "block", marginBottom: 6, fontWeight: 600, fontSize: 13, color: color.gray700 }}>
        {label}
      </label>
    )}
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      className="input"
      style={style}
      {...rest}
    />
  </div>
);

export default Input;
